import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { BreadcrumbService } from '@core/services/breadcrumb.service';
import { Breadcrumb } from '@shared/models/breadcrumb.model';
import { filter, Subject, takeUntil } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [RouterLink, RouterLinkActive, TranslatePipe],
})
export class BreadcrumbComponent implements OnDestroy {
    breadcrumbs: Breadcrumb[];

    private unsubscriber = new Subject<void>();

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private breadcrumbService: BreadcrumbService,
    ) {
        this.router.events
            .pipe(
                filter((event) => {
                    return event instanceof NavigationEnd;
                }),
            )
            .subscribe(() => {
                this.breadcrumbs = this.breadcrumbService.build(this.activatedRoute.snapshot);
                this.breadcrumbService.removeOutdated(this.breadcrumbs);
            });

        this.breadcrumbService.updatedLabel$.pipe(takeUntil(this.unsubscriber)).subscribe((updatedBreadcrumb) => {
            if (!updatedBreadcrumb) {
                return;
            }
            const index = this.breadcrumbs.findIndex((breadcrumb) => {
                return breadcrumb.alias === updatedBreadcrumb.alias;
            });
            if (index !== -1) {
                this.breadcrumbs[index].label = updatedBreadcrumb.label;
            }
        });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
